export type TimeSchedule = {
  start: string;
  end: string;
};
export type WarningStopTimeSchedules = {
  storeId: string;
  scheduleId: number;
  scheduleType: number;
  termType: number;
  startDate: string;
  endDate: string;
  isSelectDaysOfWeek: boolean[];
  timeTargetType: number;
  timeSchedules: TimeSchedule[];
};

// 警報停止時間帯一覧画面の描画に必要な情報を保持する型
export type WarningStopTimeInfo = {
  schedules: WarningStopTimeSchedules[];
};

export type TableTime = {
  time: string;
  setFlg: boolean;
};

export type SetTableTime = {
  storeName: string;
  equipmentId: string;
  equipmentName: string;
  tableTimes: TableTime[];
};

export function getTableTimeData(): SetTableTime {
  const tableTimes: any[] = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 2; m++) {
      tableTimes.push({
        time: ("0" + h).slice(-2) + ":" + ("0" + m * 30).slice(-2),
        setFlg: false
      });
    }
  }

  return {
    storeName: "",
    equipmentId: "",
    equipmentName: "",
    tableTimes: [...tableTimes]
  };
}
